import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "antd/dist/reset.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "bootstrap/dist/css/bootstrap.min.css"; // ✅ ADD THIS LINE

import RestrictedRoutes from "./common/Routs";
import { BrowserRouter } from "react-router-dom";
import { store } from "./redux/store";
import ForceLogoutModal from "./common/ForceLogoutModal";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ForceLogoutModal />
      <RestrictedRoutes />
    </BrowserRouter>
  </Provider>
);
